// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3xV6i","buttons":"PendingPaymentAlert_buttons__1pc7h"};